/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentChannel {
    ALTERNATIVE = 'ALTERNATIVE',
    BANK = 'BANK',
    CASH = 'CASH',
    COMPANY_CARD = 'COMPANY_CARD',
}
